/**
 * Safely exposes `window.clarity` and passes the arguments to the instance
 *
 * @param method method passed to the `window.clarity` instance
 * @param args arguments passed to the `window.clarity` instance
 *
 * @see {@link https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api}
 */
const ClarityAPI = (method, ...args) => {
    if (window.clarity) {
        return window.clarity.apply(null, [method, ...args]);
    }
    else {
        console.error(`Clarity instance is not initialized yet`);
    }
};
export default ClarityAPI;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQVBJLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL0FQSS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTs7Ozs7OztHQU9HO0FBQ0gsTUFBTSxVQUFVLEdBQUcsQ0FDakIsTUFBUyxFQUNULEdBQUcsSUFBNEIsRUFDL0IsRUFBRTtJQUNGLElBQUksTUFBTSxDQUFDLE9BQWtCLEVBQUU7UUFDN0IsT0FBTyxNQUFNLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsQ0FBQyxNQUFNLEVBQUUsR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFDO0tBQ3REO1NBQU07UUFDTCxPQUFPLENBQUMsS0FBSyxDQUFDLHlDQUF5QyxDQUFDLENBQUM7S0FDMUQ7QUFDSCxDQUFDLENBQUM7QUFFRixlQUFlLFVBQVUsQ0FBQyJ9